import React from 'react';
import Icon from '../../../components/AppIcon';

const InvoiceHistoryTable = ({ invoices, onDownload }) => {
  const getPaymentStatusColor = (status) => {
    const statusColors = {
      'paid': 'text-success bg-success/10',
      'pending': 'text-warning bg-warning/10',
      'overdue': 'text-error bg-error/10'
    };
    return statusColors?.[status] || 'text-muted-foreground bg-muted';
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString)?.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const getTierDisplay = (tierName) => {
    const tierMap = {
      'tier_1_10': '1-10 Employees',
      'tier_10_50': '10-50 Employees',
      'tier_50_500': '50-500 Employees',
      'tier_500_plus': '500+ Employees'
    };
    return tierMap?.[tierName] || tierName;
  };

  if (!invoices || invoices?.length === 0) {
    return (
      <div className="text-center py-12">
        <Icon name="FileText" size={48} className="mx-auto text-muted-foreground mb-4" />
        <p className="text-muted-foreground">No invoice history available</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Invoice #</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Billing Period</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Tier</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Employees</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Amount</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Status</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Date</th>
            <th className="text-right py-3 px-4 text-sm font-semibold text-foreground">Actions</th>
          </tr>
        </thead>
        <tbody>
          {invoices?.map((invoice) => (
            <tr key={invoice?.id} className="border-b border-border hover:bg-muted/50 transition-colors">
              <td className="py-3 px-4 text-sm text-foreground font-medium">
                #{invoice?.id?.slice(0, 8)?.toUpperCase()}
              </td>
              <td className="py-3 px-4 text-sm text-foreground">
                {formatDate(invoice?.billingPeriodStart)} - {formatDate(invoice?.billingPeriodEnd)}
              </td>
              <td className="py-3 px-4 text-sm text-foreground">
                {getTierDisplay(invoice?.tierAtBilling)}
              </td>
              <td className="py-3 px-4 text-sm text-foreground">
                {invoice?.employeeCountAtBilling}
              </td>
              <td className="py-3 px-4 text-sm font-semibold text-foreground">
                K{parseFloat(invoice?.amountKina)?.toFixed(2)}
              </td>
              <td className="py-3 px-4">
                <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getPaymentStatusColor(invoice?.paymentStatus)}`}>
                  {invoice?.paymentStatus?.toUpperCase()}
                </span>
              </td>
              <td className="py-3 px-4 text-sm text-muted-foreground">
                {formatDate(invoice?.billingDate)}
              </td>
              <td className="py-3 px-4 text-right">
                <button
                  onClick={() => onDownload?.(invoice)}
                  className="inline-flex items-center text-primary hover:text-primary/80 transition-colors"
                  title="Download PDF"
                >
                  <Icon name="Download" size={16} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InvoiceHistoryTable;